import React, { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useTranslationContext, translations, translateProjectStatus } from "./project-builder-main.jsx";
import { getProject } from '../../../apis/project-builder';
import { useEditProject } from "../../../components/project-builder-custom-hooks";
import Select from 'react-select';

export default function EditProjectStatus({ projectId, status, statusOptions }) {
	const { data } = useQuery(['project-detail', projectId], () => getProject(projectId));
	const { mutate: editProject, isLoading: editIsLoading } = useEditProject(projectId);

    const {translations} = useTranslationContext();
	
	const handleEditStatusChange = (selectedFilter) => {
		let projectData = {
			id: projectId,
			status: selectedFilter.value
		}

		editProject(projectData, {
			onSuccess: () => {

			}
		});
	};

	return (
		<div className="pill">
			<Select
				classNamePrefix="no-border-select"
				options={statusOptions}
				defaultValue={status}
				value={status }
				isSearchable={false}
				onChange={(value) => handleEditStatusChange(value)}
				formatOptionLabel={({ value, label }) => (
					<span>{translations[translateProjectStatus(label)] ?? label}</span>
				)}
			/>
		</div>
	);

}